import styled from 'styled-components';

export default styled.div`
  width: 100%;
  margin-top: 30px;

  .container {
    padding: 18px 0px;
  }

  @media (max-width: 1024px) {
    .container {
      padding: 10px 12px;
    }
  }

  @media (max-width: 768px) {
    .container {
      padding: 16px;
    }
  }
`;
